import { z } from "zod";

export const versionInfoSchema = z.object({
  version: z.string(),
  fullVersion: z.string(),
  deployedAt: z.string(),
});

export type VersionInfo = z.infer<typeof versionInfoSchema>;
